import { green, red } from '@mui/material/colors';
import React from 'react';

import goIcon from '../../images/icons/go.svg';
import stopIcon from '../../images/icons/stop.svg';

interface SituationIndicatorProps {
    negativeStatusText: string;
    normalFont?: boolean;
    positiveStatusText: string;
    situation?: boolean;
    style?: React.CSSProperties;
    textOnly?: boolean;
}

export const SituationIndicator: React.FC<SituationIndicatorProps> = ({
    negativeStatusText,
    normalFont = false,
    positiveStatusText,
    situation = false,
    style = {},
    textOnly = false,
}) =>
    textOnly ? (
        <div
            style={{
                padding: '0.25rem',
                backgroundColor: situation ? green[800] : red[800],
                color: '#fff',
                borderRadius: 10,
                textTransform: 'uppercase',
                fontSize: 'small',
                fontWeight: normalFont ? 'normal' : 'bold',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '32px',
                width: '90px',
            }}
        >
            {situation ? positiveStatusText : negativeStatusText}
        </div>
    ) : (
        <img
            src={situation ? goIcon : stopIcon}
            alt={situation ? positiveStatusText : negativeStatusText}
            style={style}
        />
    );
